var exports = {
  "hz": "referenceToken__NGflbY",
  "EX": "small__EZKH0y",
  "Ij": "fullWidth__XVrwS2",
  "i2": "loadingName__33noeM",
  "UU": "name__gkxYZI",
  "h_": "description__99MiHU",
  "LX": "trailingVisual__rjTks5",
  "DT": "removeButton__wb9AZ1",
  "Kk": "icon__0tE5zH",
  "kl": "openIcon__pmyI3N",
  "kX": "closedIcon__E0uVbG",
  "Ms": "pullRequestClosedIcon__ZdmLRl",
  "il": "pullRequestMergedIcon__b9xoNm",
  "LP": "figmaIconOuter__fy43Ct",
  "c6": "figmaIcon__3ejNUp",
  "ZD": "nodeIconOuter__v97cjn",
  "A$": "jobIconOuter__Qu5D-5",
};

module.exports = exports;
